<div class="p-3" style="border-color: #3b82f6">
  <div class="flex">
    <div class="font-semibold mb-4 inline-block">{{'global.categories' | translate}}</div>
  <!--   <div class="inline-block ml-6">
      <p class="primary-link font-semibold link" (click)="openRuleModal()">
        <i class="pi pi-cog mr-1"></i>
        {{ "global.rule" | translate }}
      </p>
    </div> -->
  </div>
  <div class="grid">
    <div class="col-5 font-bold">
      <div class="line-wrapper">
        <span>{{ "importWorkflow.vendorCategories" | translate }}</span>
        <div class="line"></div>
      </div>
    </div>
    <div class="col-7 font-bold">
      <div class="line-wrapper">
        <div>
          {{ "importWorkflow.propositions" | translate }}
          @if (type === "toConfirm") {
            <i
              class="pi pi-info-circle ml-5"
              pTooltip="{{ 'importWorkflow.propositionInfoToConfirm' | translate }}"></i>
          } @else if (type == "unIdentified") {
            <i
              class="pi pi-info-circle ml-5"
              pTooltip="{{ 'importWorkflow.propositionInfoUnIdentified' | translate }}"></i>
          } @else {
            <i
              class="pi pi-info-circle ml-5"
              pTooltip="{{ 'importWorkflow.propositionInfoIdentified' | translate }}"></i>
          }
        </div>
        <div class="line"></div>
      </div>
    </div>
    @for (node of displayedNodes; track $index) {
      <div class="col-5 m-auto">
        <div class="line-wrapper">
          <span>{{ node?.vendorTypologyCategory }} </span>
          <div class="line"></div>
        </div>
      </div>
      <div class="col-5 m-auto">
        <div class="flex">
          <div class="flex-auto">
            @if (node.condition) {
              <div class="rules_field">
                <p-autoComplete [multiple]="true" [typeahead]="false" [style]="{ width: '100%' }" [(ngModel)]="node.mappedTypologies" [disabled]="true">
                  <ng-template let-item pTemplate="selectedItem">
                    {{ item.typologyLabel }}
                  </ng-template>
                </p-autoComplete>
                <i
                  class="pi pi-exclamation-circle"
                  pTooltip="{{ 'importWorkflow.ruleApplied' | translate }}"
                  (click)="showRule(node)"></i>
              </div>
            } @else {
              @if (node.mappedTypologies?.length > 1) {
                <p-select
                  [style]="{ width: '100%' }"
                  [(ngModel)]="node.choosenTypology"
                  [options]="node.mappedTypologies"
                  optionLabel="typologyLabel">
                  <ng-template let-categ pTemplate="item">
                    <div class="flex">
                      <div class="flex-1">{{ categ.typologyLabel }}</div>
                      <div>{{ (categ.score * 100).toFixed(0) }}</div>
                    </div>
                  </ng-template>
                </p-select>
              } @else if (node.mappedTypologies?.length == 1) {
                <div class="rules_field">
                  <input
                    [(ngModel)]="node.mappedTypologies[0].typologyLabel"
                    class="w-full"
                    type="text"
                    pInputText
                    [disabled]="node.associated" />
                  @if (node.mappedTypologies[0].rule) {
                    <i
                      class="pi pi-question-circle"
                      pTooltip="{{ 'importWorkflow.ruleApplied' | translate }}"
                      (click)="showRule(node)"></i>
                  }
                </div>
              } @else {
                <p-treeSelect
                  class="md:w-20rem w-full"
                  containerStyleClass="w-full"
                  [showClear]="true"
                  [options]="taxo"
                  (onNodeSelect)="onSelectedNodeDrop($event, node)"
                  placeholder="{{ 'global.selectItem' | translate }}">
                  <ng-template let-node pTemplate="default">
                    <div>
                      <span>{{ node.categoryLabelLoc }}</span>
                    </div>
                  </ng-template>
                </p-treeSelect>
              }
            }
          </div>
          <div class="flex-initial ml-2">
            <p-button icon="pi pi-pencil" [outlined]="true" (onClick)="customTypologySelection(node)"></p-button>
          </div>
        </div>
      </div>
      <div class="col-2 text-right">
        <div class="line-wrapper">
          <div class="line text-500"></div>
          @if (node.associated) {
            <p-button [severity]="'success'" [disabled]="true">
              <i class="pi pi-check mr-1"></i> {{ "buttons.associated" | translate }}
            </p-button>
          } @else {
            <p-button (click)="assiciate(node)" [disabled]="node.mappedTypologies.length === 0">
              <i class="pi pi-link mr-1"></i> {{ "buttons.associate" | translate }}
            </p-button>
          }
        </div>
      </div>
    }
  </div>
  <div class="flex justify-content-center mt-5">
    <p-paginator 
        (onPageChange)="onPageChange($event)" 
        [first]="first" 
        [rows]="rowsPaginator" 
        [totalRecords]="totalRecordsPaginator" 
        [rowsPerPageOptions]="[10, 30, 50, 100]" />
  </div>
</div>

<p-dialog
  [(visible)]="showModal"
  header="{{ 'importWorkflow.chooseTypology' | translate }}"
  [dismissableMask]="false"
  [modal]="true"
  [style]="{ width: '45rem' }"
  draggable="false">
  <p-tree
    (onNodeSelect)="onSelectedNode($event)"
    [scrollHeight]="'400px'"
    [value]="taxo"
    [filter]="true"
    filterBy="categoryLabelLoc"
    selectionMode="single"
    [(selection)]="selectedNode">
    <ng-template let-node pTemplate="default">
      <div>
        @if (node.hasChildren == false) {
          <div class="typology">
            <span class="p-ml-2">{{ node.categoryLabelLoc }}</span>
          </div>
        } @else {
          <span class="p-ml-2" style="font-size: 12px">{{ node.categoryLabelLoc }}</span>
        }
      </div>
    </ng-template>
  </p-tree>
  <ng-template pTemplate="footer">
    <p-button
      label="{{ 'buttons.cancel' | translate }}"
      [outlined]="true"
      severity="secondary"
      (onClick)="showModal = false" />
    <p-button
      label="{{ 'buttons.confirm' | translate }}"
      [outlined]="true"
      severity="secondary"
      (onClick)="confirmNode()" />
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showRuleModal"
  header="{{ 'importWorkflow.associationRules' | translate }}"
  [dismissableMask]="false"
  [modal]="true"
  [style]="{ width: '65rem', height: '45rem' }"
  draggable="false">
  <div>
    <div class="info mb-4 mt-3">
      <div class="flex align-items-end font-italic" [tp]="tpl" [tpInteractive]="true" [tpPopperWidth]="'600px'">
        Vous pouvez définir des règles qui appliquent une catégorie particulière lorsqu'un attribut spécifique est
        présent ou remplit une condition.
        <i class="pi pi-info-circle ml-2"></i>
      </div>
    </div>
    <ng-template #tpl>
      <div class="flex align-items-center text-justify p-2" style="font-size: 11px">
        <ol>
          <li><b>Choisissez une catégorie :</b></li>
          Commencez par sélectionner la catégorie à laquelle le mapping s'appliquera (par exemple : "Produit",
          "Service", "Commande"). Cela permet de définir dans quel contexte le mapping sera utilisé.
          <li><b>Sélectionnez l'attribut à utiliser :</b></li>
          Choisissez l'attribut sur lequel vous souhaitez baser le mapping (par exemple :
          "Couleur", "Taille", "Marque", etc.). Cet attribut sera utilisé pour vérifier si une condition est remplie.
          <li><b>Définissez la condition :</b></li>
          Une fois l'attribut choisi, vous pouvez spécifier une condition pour cet attribut. Par exemple, vous pouvez
          indiquer que l'attribut doit exister (être présent) ou bien avoir une valeur spécifique. Exemples de
          conditions : "Si l'attribut existe" "Si la valeur de l'attribut contient 'Premium'"
          <li><b>Assignez une catégorie :</b></li>
          Ensuite, choisissez la catégorie à appliquer lorsque la condition est remplie. Exemple : "Si l'attribut
          Couleur est égal à 'Rouge', alors la catégorie sera 'Vêtements Rouges'."
        </ol>
      </div>
    </ng-template>
    <div class="pb-3">
      <span class="mr-1">{{ "importWorkflow.forCategory" | translate }}</span>
      <p-select
        [style]="{ width: '300px' }"
        [(ngModel)]="condition.typology"
        [options]="nodes"
        placeholder="{{ 'importWorkflow.selectVendorCategory' | translate }}"
        optionLabel="vendorTypologyCategory">
      </p-select>
    </div>
    <div class="pl-7">
      @for (condition of condition.rules; track $index) {
        <div class="mb-3">
          <div class="pb-3">
            <span class="mr-1">{{ "importWorkflow.ifAttribute" | translate }} </span>
            <input
              type="text"
              pInputText
              class="mr-1"
              [(ngModel)]="condition.attribute"
              placeholder="{{ 'importWorkflow.chooseAttribute' | translate }}" />
            <p-select
              class="mr-1"
              [style]="{ width: '170px' }"
              (ngModelChange)="changeRuleType(condition)"
              [options]="conditions"
              [(ngModel)]="condition.type">
              <ng-template let-condition pTemplate="selectedItem">
                <div class="flex">
                  <div class="flex-1">{{ condition | translate }}</div>
                </div>
              </ng-template>
              <ng-template let-condition pTemplate="item">
                <div class="flex">
                  <div class="flex-1">{{ condition | translate }}</div>
                </div>
              </ng-template>
            </p-select>
            @if (condition.type == "importWorkflow.contains") {
              <input
                type="text"
                pInputText
                class="mr-1"
                [(ngModel)]="condition.value"
                placeholder="{{ 'importWorkflow.chooseAttributeValue' | translate }}" />
              @for (subCondition of condition.subConditions; track $index) {
                <br />
                <div class="mt-2 inline-block">
                  <p-select class="mr-1" [options]="subConditions" [(ngModel)]="subCondition.type">
                    <ng-template let-subCondition pTemplate="selectedItem">
                      <div class="flex">
                        <div class="flex-1">{{ 'global.'+subCondition | translate }}</div>
                      </div>
                    </ng-template>
                    <ng-template let-subCondition pTemplate="item">
                      <div class="flex">
                        <div class="flex-1">{{ 'global.'+subCondition | translate }}</div>
                      </div>
                    </ng-template>
                  </p-select>
                  <input
                    type="text"
                    pInputText
                    class="mr-1"
                    [(ngModel)]="subCondition.value"
                    placeholder="{{ 'importWorkflow.chooseAttributeValue' | translate }}" />
                  <p-button
                    [style]="{ color: 'red' }"
                    icon="pi pi-trash"
                    [link]="true"
                    (click)="removeRule(condition, subCondition)"></p-button>
                </div>
              }
              <p-button
                icon="pi pi-plus-circle"
                label="{{ 'buttons.addSubCondition' | translate }}"
                [link]="true"
                (click)="addRule(condition)"></p-button>
            }
          </div>
          <div class="pl-7">
            <span class="pb-1 mr-1">{{ "importWorkflow.thenCategoryIs" | translate }}</span>
            <p-treeSelect
              class="md:w-20rem"
              containerStyleClass="w-25rem"
              [showClear]="true"
              [options]="taxo"
              [(ngModel)]="condition.result"
              placeholder="{{ 'global.selectItem' | translate }}">
              <ng-template let-category pTemplate="default">
                <div>
                  <span>{{ category.categoryLabelLoc }}</span>
                </div>
              </ng-template>
              <ng-template let-selectedItem pTemplate="value">
                @if (selectedItem) {
                  <div>
                    {{ selectedItem?.categoryLabelLoc }}
                  </div>
                } @else {
                  <span class="text-gray-500">{{ "importWorkflow.selectCategory" | translate }}</span>
                }
              </ng-template>
            </p-treeSelect>
            @if ($index > 0) {
              <p-button
                [style]="{ color: 'red' }"
                icon="pi pi-trash"
                [link]="true"
                (click)="removeCondition(condition)"></p-button>
            }
          </div>
        </div>
      }
      <p-button
        icon="pi pi-plus-circle"
        label="{{ 'buttons.addCondition' | translate }}"
        [link]="true"
        (click)="addCondition()"></p-button>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="{{ 'buttons.cancel' | translate }}"
      [outlined]="true"
      severity="secondary"
      (onClick)="showRuleModal = false" />
    <p-button
      label="{{ 'buttons.confirm' | translate }}"
      [outlined]="true"
      severity="secondary"
      (onClick)="confirmRule()" />
  </ng-template>
</p-dialog>
